<template>
    <div id="findwords">
        <div v-if="loaded" class="preloader">
            <img alt="" src="../assets/images/gifs/lexin-loader.gif">
        </div>
		<div class="row">
            <div class="col-12 col-sm-12 col-md-7">
                <div class="breadcrumbs">
                    <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
                    <ul>
                        <li>
                            <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
                        </li>
                        <li>
                            <font-awesome-icon icon="arrow-right" class="right-agap" />
							<router-link tag="a" to="/">{{ $t('message.main-page') }}</router-link>
                        </li>
                        <li>
                            <font-awesome-icon icon="arrow-right" class="right-agap" />
							<span>{{ $t('message.search') }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <Language />
        </div>
        <div class="row">
            <div class="col-12">
                <h1>
                    <span v-if="isSearch">{{ $t('message.search') }}</span>
                    <span v-else>{{ $t('message.main-page') }}</span>
                </h1>
                <div class="clearfix"></div>
                <div class="home-info">
                    <h2 class="title">{{ $t(dictionary) }}</h2>
                    <p class="mb-0">
                        <router-link tag="a" to="/">{{ $t('message.choose-another-dictionary') }}</router-link>
                        <!-- |
                        {{ $t('message.switch_to') }}: <a @click="toDictionarySwitch()" class="link" tabindex="0">{{ $t(dictionarySwitch) }}</a>
                        -->
                    </p>
                </div>
            </div>
        </div>
        <div class="search-form" id="search-form-id">
            <form @submit.prevent="search">
                <div class="row">
                    <div class="col-10 col-sm-6 col-md-6 col-lg-6">

                        <input
                            class="form-control form-input a-text-field"
                            id="search"
                            name="search"
                            ref="searchInput"
                            :title="$t('message.search')"
                            :aria-label="$t('message.search-placeholder')"
                            :disabled="loaded"
                            v-bind:class="{required: (isRequired && (searchString === '' || searchString === null))||noRecords, inputDisabled:loaded}"
                            :placeholder="$t('message.search-placeholder')"
                            type="text"
                            v-model="searchString"
                        />

                    </div>
                    <div class="col-2 col-sm-4 col-md-4 col-lg-4">
                        <input class="form-btn" type="submit" :value="$t('message.search')">
                    </div>
                </div>
                <div class="row" v-if="isRequired && (searchString ==null||searchString.trim() === '')">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-danger search-text-message">
                        {{ $t('message.searchvalidation') }}
                    </div>
                </div>
            </form>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                <LexinKeyboard @add-to-search="addToSearchInput"></LexinKeyboard>
            </div>
        </div>
        <div id="start-search"></div>
        <div v-if="isActive" style="color:black;">
            <ul class="radio-list">
                <li v-if="showIncludeEnglish()">
                    <label for="searchEngLangInput"><input type="checkbox" id="searchEngLangInput" name="searchEngLang" v-model="includeEngLanguage" value="1" />
                     {{ $t('message.include_english') }}</label>
                </li>
            </ul>
        </div>
        <div class="row">
            <div class="col-12">
                <p>
                   <router-link tag="a" :to= "{ name: 'AboutSearchComponent'}"> {{ $t('message.help-for-searching') }}</router-link>
                   <a href="#" class="link-keyboard" @click="goToTop()">{{ $t('message.to-top') }}</a>
                </p>
            </div>
        </div>
        <div v-if="searchStringCopy!==null && searchStringCopy.trim()!=='' && !exactMatchFound && !noRecords" class="my-2">
            <span class="records-info">{{ $t('message.records-info-1') }} "{{searchStringCopy}}"{{ $t('message.records-info-2') }}</span>
        </div>
        <div v-if="noRecords" class="text-danger">
            {{ $t('message.no-hits') }}
        </div>
        <div v-if="resultLength && isSearch !==true" class="row">
            <div v-if="resultLength && isSearch !==true" class="col-sm-4 col-12">{{(page-1)*10+1}} - {{(page-1)*10 +finalResult.length}} {{ $t('message.of') }} {{resultLength}}</div>
            <div class="col-sm-8 col-12 btn-center" v-if="resultLength > 10">
                <button :disabled="!isPrevVisible" @click="previousPage" v-on:keyup.left="previousPage"  class="btn custom-btn margin">{{ $t('message.previous') }}</button>
                <button :disabled="!isNesteVisible" @click="nextPage" v-on:keyup.right="nextPage" class="btn custom-btn margin">{{ $t('message.next') }}</button>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="row search-matches">
            <div id="listingblock1"><span lang="no">nakke.</span></div>
            <div class="col-12" v-if="(firstLanguage.toLowerCase()==='bokmål'||dictionary==='message.bokmal-monolingual') && !noRecords && isSearch !== true">
                <div v-if="result[0] !== undefined" v-for="(result, resultKey) in finalResult" :key="result[0].id">
                    <pictureresultbok
                        :Val.sync="result"
                        :resultIndex="resultKeyToString(resultKey)"
                        :lang="picked"
                        :secondLang="secondLanguage"
                        :displayLang="firstOption"
                        :searchInput.sync="searchString"
                        :includeEngLanguage="includeEngLanguage"
                        :loaded.sync="loaded"
                        :isPicturepage="false"
                        :dictionary="dictionary"
                        :ordbankList="ordbankList"
                        :partOfSpeachInfo="partOfSpeachInfo"
                    ></pictureresultbok>
                </div>
            </div>
            <div class="col-12" v-if="(firstLanguage.toLowerCase()==='nynorsk'||dictionary==='message.nynorsk-monolingual') && !noRecords && isSearch !== true">
                <div v-if="result[0] !== undefined" v-for="(result, resultKey) in finalResult" :key="result[0].id">
                    <pictureresultnny
                        :Val.sync="result"
                        :resultIndex="resultKeyToString(resultKey)"
                        :lang="picked"
                        :secondLang="secondLanguage"
                        :displayLang="firstOption"
                        :searchInput.sync="searchString"
                        :includeEngLanguage="includeEngLanguage"
                        :loaded.sync="loaded"
                        :isPicturepage="false"
                        :dictionary="dictionary"
                        :ordbankList="ordbankList"
                        :partOfSpeachInfo="partOfSpeachInfo"
                    ></pictureresultnny>
                </div>
            </div>
                <div class="page-main" v-if="resultLength && resultLength > 10 && isSearch !==true" >
                     <b-pagination
                         v-model="page"
                         @change="clickCallback"
                        :total-rows="resultLength"
                        first-number
                        last-number
                        :per-page="10"
                        :prev-text="$t('message.previous')"
                        :next-text="$t('message.next')"

                    ></b-pagination>
                </div>
            <a id="toTop"  href="javascript:;" style="display:none;" @click="goToTop"><span id="toTopHover"></span><img width="40" height="40" alt="To Top" src="../assets/images/to-top@2x.png"></a>
        </div>
    </div>
</template>

<script>
import Language from "./Language.vue";
import pictureresultbok from './pictureResultBok.vue'
import pictureresultnny from './pictureResultNny.vue'
import vuejspaginate from 'vuejs-paginate'
import axios from 'axios'
import LexinKeyboard from "@/components/LexinKeyboard.vue";

export default {
		name: "FindwordsComponent",
		components: {
            LexinKeyboard,
            Language,
            pictureresultbok,
            pictureresultnny,
            vuejspaginate
        },
        data() {
            return {
                isInitialized: false,
                dictionary: null,
                dictionarySwitch: null,
                picked: "All",
                includeEngLanguage: false,
                searchString: '',
                isActive: false,
                loaded:false,
                firstLanguage:'',
                secondLanguage:'',
                firstOption:'',
                secondOption:'',
                thirdOption:'',
                isbothForms: false,
                finalResult: [],
                ordbankList: {},
                partOfSpeachInfo: {},
                isRequired:false,
                noRecords:false,
                isSearch:false,
                resultLength:null,
                page:1,
                isPrevVisible:false,
                isNesteVisible:true,
                pageArrayLength:null,
                array:[],
                languageString:'',
                tableName:'',
                source:'',
                cacheResult: [],
                exactMatchFound:true,
                searchStringCopy:'',
                languageCodeList:[
                    {lang:'eng',langISOCode:'en'},
                    {lang:'nny',langISOCode:'nn'},
                    {lang:'nbo',langISOCode:'nb'}
                ]
            }
        },
        computed: {
            selectedLanguageCode () {
                return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
            },
            rows() {
                return this.items.length
            }
        },
        created() {
            let incEngLang = localStorage.getItem('lexinFindwordsIncEngLang');
            if (incEngLang === '1' || incEngLang === '0') {
                if (incEngLang === '1') {
                    this.includeEngLanguage = true;
                } else {
                    this.includeEngLanguage = false;
                }
            } else {
                this.includeEngLanguage = false;
            }

            this.isSearch = this.$route.params.isSearch;
            this.setRouteValues();
            this.isbothForms = this.dictionary == "message.bokmal-nynorsk" || this.dictionary == "message.nynorsk-bokmal" ? true : false;
            if(this.isSearch===true){
                this.searchString='';
            }
            this.searchString = localStorage.getItem('searchWord');

            if ((typeof this.searchString !== 'string' || this.searchString.trim() !== '') &&
                (this.$route.query.q || '') !== '') {
                this.searchString = this.$route.query.q;
            }

            if(this.searchString !== null && this.searchString != ''){
                this.searchWord();
            }

            $(document).scroll(function() {
               var y = $(this).scrollTop();
                y > 600 ? $('#toTop').fadeIn() : $('#toTop').fadeOut();
            });

            this.goToTop('#start-search');
        },
        methods:{
            toDictionarySwitch(){
                const routeData = this.$router.resolve({
                    name: 'FindwordsComponent',
                    params: {
                        dictionary: this.dictionarySwitch
                    }
                });

                if (window.location.hash === routeData.href) {
                    window.location.href = routeData.href;
                    window.location.reload();
                } else {
                    window.location.href = routeData.href;
                }
            },
            showIncludeEnglish() {
                let value = true;
                let currentLang = this.dictionary.split('-')[1] || '';
                const excludeLanguages = [
                    'bokmal',
                    'nynorsk',
                    'english'
                ];

                if (excludeLanguages.includes(currentLang)) {
                    value = false;
                }

                return value;
            },
            getLanguageString() {
                let value = this.languageString;
                if (this.showIncludeEnglish()) {
                    if (this.includeEngLanguage && !value.includes("|B-%")) {
                        value += '|B-%';
                    } else if (!this.includeEngLanguage && value.includes("|B-%")) {
                        value = value.replace('|B-%', '');
                    }
                }

                return value;
            },
            addToSearchInput(searchValue) {
                this.searchString = searchValue;
            },
            search(isRequired = true){
                this.loaded = false;
                this.noRecords = false;
                this.finalResult = [];
                // // this.cacheResult = [];
                this.page = 1;
                this.resultLength = null;
                this.isPrevVisible = false;
                this.isNesteVisible = true;
                this.searchWord(isRequired);
            },
            //#region function to get the data from database depending upon the searchword
            //this method will return array of words and total no of records found for searchword
            searchWord(isRequired = true){
                var _this = this;
                var CancelToken = axios.CancelToken;
                this.source = CancelToken.source();
                $(".search-matches").css('visibility', 'hidden');
                _this.isSearch = true;

                let searchString = '';
                if (_this.searchString) {
                    searchString = _this.searchString.trim();
                }

                if (this.$route.query.q === undefined || this.$route.query.q !== searchString) {

                    const hash = window.location.hash;

                    const [path, queryString = ''] = hash.split('?');
                    const params = new URLSearchParams(queryString);

                    params.set('q', searchString);

                    const newHash = `${path}?${params.toString()}`;

                    window.history.replaceState(
                        null,
                        '',
                        newHash
                    );

                    // Can not be used, since the replacement causes problems with query history and
                    // register statistics / external resources.
                    //
                    // this.$router.replace({ query: { ...this.$route.query, q: searchString } });
                }

                if (_this.searchString === null || _this.searchString.trim() === '') {
                    _this.isRequired = isRequired;
                    _this.resultLength = null;
                } else {
                    let includeEngLang = 0;
                    if (this.includeEngLanguage) {
                        includeEngLang = 1;
                    }
                    this.loaded = true;
                    this.cacheResult = [];
                    try {
                        this.$http.get("findwords", {
                            params: {
                                searchWord: (_this.searchString.toLowerCase()).replace(/[, ^|;/"]/g, " ").replace(/[()]/g, " ").trim(),
                                lang: _this.firstOption.toLowerCase(),
                                page: _this.page,
                                selectLang: _this.picked.toLowerCase(),
                                includeEngLang: includeEngLang
                            },
                            cancelToken: this.source.token
                        }).then(response => {
                            $('div.search-matches').css('visibility', 'visible');
                            $('.form-btn').blur();
                            this.loaded = false;
                            if (response === undefined ||
                                response.data === undefined ||
                                response.data.result === undefined) {
                                return;
                            }
                            var data = response.data.result;
                            _this.array = Object.values(response.data.resArray).map(x => x.id);
                            var grouped = [];
                            _.map(data, function (list) {
                                _.each(_this.array.slice(0, 10), function (id) {
                                    grouped.push(_.map(_.filter(list, {id: id})));
                                });
                            });

                            _this.finalResult = grouped;

                            _this.ordbankList = {};
                            if (_this.isObject(response.data.ordbankList)) {
                                _this.ordbankList = response.data.ordbankList;
                            }

                            _this.partOfSpeachInfo = {};
                            if (_this.isObject(response.data.partOfSpeachInfo)) {
                                _this.partOfSpeachInfo = response.data.partOfSpeachInfo;
                            }

                            _this.resultLength = _this.array.length;
                            _this.languageString = response.data.lang;
                            _this.tableName = response.data.tableName;
                            _this.exactMatchFound = response.data.exactMatchFound;
                            _this.noRecords = (_this.finalResult.length > 0) ? false : true;
                            _this.pageArrayLength = Math.ceil(_this.resultLength / 10);
                            _this.isNesteVisible = (_this.page < _this.pageArrayLength) ? true : false;
                            _this.$route.params.isSearch = false;
                            _this.cacheResult.push({
                                page: _this.page,
                                includeEngLang: includeEngLang,
                                result: _this.finalResult,
                                ordbankList: _this.ordbankList,
                                partOfSpeachInfo: _this.partOfSpeachInfo,
                            });

                            if (_this.exactMatchFound == false && _this.resultLength) {
                                _this.searchStringCopy = _this.searchString;
                            }

                            if (_this.firstOption) {

                                _paq.push(['trackSiteSearch',
                                    // Search keyword searched for
                                    _this.searchString.toString(),
                                    // Search category (optional), remove special characters
                                    this.$i18n.messages.nbo.message[_this.firstOption.replace('å', 'a')],
                                    // Number of search results
                                    _this.resultLength
                                ]);
                            } else {
                                _paq.push(['trackSiteSearch',
                                    // Search keyword searched for
                                    _this.searchString.toString(),
                                    // Search category (optional), remove special characters
                                    '',
                                    // Number of search results
                                    _this.resultLength
                                ]);
                            }
                            _this.goToTop('#start-search');

                            this.$nextTick(() => {
                                _this.$refs.searchInput.focus();
                            });
                        }).catch(err => {
                            _this.loaded = false;
                            _this.$route.params.isSearch = false;
                            $('div.search-matches').css('visibility', 'visible');
                            $('.form-btn').blur();
                            this.$nextTick(() => {
                                _this.$refs.searchInput.focus();
                            });
                        });
                    } catch (error) {
                        _this.loaded = false;
                        _this.$route.params.isSearch = false;
                        $('div.search-matches').css('visibility', 'visible');
                        $('.form-btn').blur();
                    }
                }
            },
            //#endregion

            //#region function to get the data according to the pagination
            //this method will navigate the search result to next and prev page based on user action
            nextPrevSearchResult(){
                    var _this = this;
                    this.loaded=true;
                    var result = _this.cacheResult.find(function (obj) {
                        let isEqual = false;
                        if (_this.includeEngLanguage && obj.includeEngLang == '1') {
                            isEqual = true;
                        } else if (!_this.includeEngLanguage && obj.includeEngLang == '0') {
                            isEqual = true;
                        }

                        return ((obj.page === _this.page) && isEqual == true);
                    });

                    if (result === undefined){
                        var start = (_this.page - 1) * 10;
                        var end = start + 10;
                        var array = _this.array.slice(start,end);

                        let includeEngLang = '0';
                        if (this.includeEngLanguage) {
                            includeEngLang = '1';
                        }
                        let languageString = _this.getLanguageString();

                        this.$http.get("nextPrevResultWithOrdbank",{
                            params: {
                                searchResArray: array,
                                table: _this.tableName,
                                page: _this.page,
                                selectLang: _this.picked.toLowerCase(),
                                language: languageString,
                                includeEngLang: includeEngLang
                            }
                        }).then(response => {
                            this.loaded=false;
                            var grouped = [];

                            _.map(response.data.next_prev, function(list) {
                                _.each(
                                array, function(id){
                                    grouped.push(
                                        _.map(
                                            _.filter(list,{
                                                    id:id
                                                })
                                            )
                                        );
                                    });
                                });

                            _this.finalResult = grouped;
                            _this.ordbankList = response.data.ordbank || {};
                            _this.partOfSpeachInfo = response.data.partOfSpeachInfo || {};
                            _this.$route.params.isSearch=false;
                            _this.cacheResult.push({
                                page: _this.page,
                                includeEngLang: includeEngLang,
                                result: _this.finalResult,
                                ordbankList: _this.ordbankList,
                                partOfSpeachInfo: _this.partOfSpeachInfo,
                            });
                        })
                    } else {
                        this.loaded=false;
                        _this.finalResult = result.result;
                        _this.ordbankList = result.ordbankList;
                        _this.partOfSpeachInfo = result.partOfSpeachInfo;
                        _this.$route.params.isSearch = false;
                    }
            },
            //#endregion

            //#region  function to get the previous page record
            previousPage(){
                this.page = this.page-1;
                this.innervalue =this.page;
                this.checkPrevNext();
                // this.goToTop('#start-search');
                this.nextPrevSearchResult();
            },
            //#endregion

            isObject(value) {
                return (
                    typeof value === 'object' &&
                    value !== null &&
                    !Array.isArray(value)
                );
            },

//#region  function to get the next page record
            nextPage(){
                this.page = this.page+1;
                this.innervalue =this.page;
                this.checkPrevNext();
                // this.goToTop('#start-search');
                this.nextPrevSearchResult();
            },
            //#endregion

            //#region function to disable and enable the previous and next button at first and last page and to get the
            checkPrevNext(){
                this.page > 1?this.isPrevVisible= true: this.isPrevVisible=false;
                this.page < Math.ceil(this.resultLength/this.finalResult.length)?this.isNesteVisible=true: this.isNesteVisible=false;
            },
            //#endregion

            //#region function to set the radio buttons values and to get the selected radio button value.
            setRouteValues: function(){
                    this.dictionary = this.$route.params.dictionary.split('?')[0];

                    if (this.dictionary.includes('.bokmal')) {
                        if (this.dictionary.includes('nynorsk')) {
                            this.dictionarySwitch = this.dictionary.replace('bokmal-nynorsk', "nynorsk-bokmal");
                        } else {
                            this.dictionarySwitch = this.dictionary.replace('bokmal', "nynorsk");
                        }
                    } else if (this.dictionary.includes('.nynorsk')) {
                        if (this.dictionary.includes('bokmal')) {
                            this.dictionarySwitch = this.dictionary.replace('nynorsk-bokmal', "bokmal-nynorsk");
                        } else {
                            this.dictionarySwitch = this.dictionary.replace('nynorsk', "bokmal");
                        }
                    }

                    this.isActive = this.dictionary === 'message.bokmal-monolingual' || this.dictionary ===
                        'message.nynorsk-monolingual' ? false : true;
                    if(this.isActive){
                        var options = this.$t(this.dictionary).replace(/<\/?[^>]+(>|$)/g, "").split('-');
                        this.firstOption =  options[1];
                        this.secondOption = options[0];
                        this.firstLanguage= this.secondOption.toLowerCase() ;
                        this.secondLanguage= this.firstOption.toLowerCase() ;
                        this.firstOption=this.firstLanguage+'-'+this.secondLanguage;
                    }
                    else{
                        this.firstOption= (this.dictionary === 'message.bokmal-monolingual') ? 'bokmål' : 'nynorsk';
                    }
                    this.picked=this.firstOption;
            },
            //#endregion
            clickCallback: function(page){
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                   $('.pagination').removeClass('.pagination li	a:hover')
                 }
                this.page = page;
                this.checkPrevNext();
                this.goToTop('#start-search');
                this.nextPrevSearchResult();
            },
            goToTop: function(elementId=null){
                let searchFormHeight = 0;

                if (typeof elementId === 'string' && $(elementId).length) {
                    searchFormHeight = $(elementId).offset().top;
                    if ($('div.search-form').length) {
                        searchFormHeight = searchFormHeight - $('div.search-form').height() - 35;
                    }
                }

                $("html, body").animate({scrollTop: searchFormHeight}, "fast");

                this.$nextTick(() => {
                    this.$refs.searchInput.focus();
                });
            },
            resultKeyToString(resultKey) {
                return resultKey.toString();
            }
        },
        updated(){
			this.isSearch = this.$route.params.isSearch;
            this.isInitialized = true;
        },
        mounted(){
            let _this = this;
            this.$on('add-to-search', this.addToSearchInput)
            this.$eventBus.$on("send-temp", data => {
                    _this.page = 1;
                    _this.searchString = data;
                    _this.searchWord();
                    _this.goToTop();
            });

            this.$nextTick(() => {
                _this.$refs.searchInput.focus();
            });
        },
        watch: {
            $route: {
                handler: function(newVal) {
                    if (newVal.params.isSearch == true) {
                        this.loaded = false;
                        if (this.source != '') {
                            this.source.cancel();
                        }
                        this.setRouteValues();
                        this.searchString = '';
                        this.searchStringCopy = '';
                        this.isSearch = true;
                        this.isRequired = false;
                        this.noRecords = false;
                        this.goToTop();
                        this.$nextTick(() => {
                            this.$refs.searchInput.focus();
                        });
                        this.cacheResult = [];
                    }

                    if (newVal.query.q !== undefined && newVal.query.q !== this.searchString) {
                        this.searchString = newVal.query.q;
                        this.search();
                    }
                },
                immediate: false
            },
            includeEngLanguage: {
                handler: function(newVal) {
                    if (this.isInitialized === true) {
                        let includeEngLanguage = '0';
                        if (newVal) {
                            includeEngLanguage = '1';
                        }

                        localStorage.setItem('lexinFindwordsIncEngLang', includeEngLanguage);

                        this.isSearch = true;
                        this.isRequired = false;
                        this.search(false);
                    }
                },
                immediate: false,
            }
        }
}

</script>

